/**
 * Registry of every module GUI the host knows how to mount.
 *
 * Module packages are sibling pnpm workspaces. The host lazy-imports them so
 * the portal still loads cleanly when a module hasn't been built yet —
 * ModuleHost shows a "not yet installed" placeholder.
 *
 * Adding a new module: drop it in this object, drop the matching package
 * name in src/types.d.ts, and the host wires it up automatically.
 */
interface ModuleEntry {
  name: string;
  description: string;
  accent: string | null;
  lazy: () => Promise<unknown>;
}

export const MODULE_REGISTRY = {
  shopee: {
    name: 'Shopee',
    description: 'Orders, products, escrow, returns, labels',
    accent: '#EE4D2D',
    lazy: () => import('@admin-portal/shopee-gui'),
  },
  roamwifi: {
    name: 'RoamWiFi',
    description: 'eSIM catalog, orders, ICCID lookup, push events',
    accent: '#0AA0C6',
    lazy: () => import('@admin-portal/roamwifi-gui'),
  },
  orders: {
    name: 'Orders',
    description: 'Sale-order queue, returns, routing, settings',
    accent: null,
    lazy: () => import('@admin-portal/orders-gui'),
  },
  worldmove: {
    name: 'Worldmove',
    description: 'Catalog, eSIM order, top-up, ICCID query',
    accent: '#dc2626',
    lazy: () => import('@admin-portal/worldmove-gui'),
  },
  web: {
    name: 'Web · Auth',
    description: 'LINE users, admins, sessions, order links',
    accent: '#0f172a',
    lazy: () => import('@admin-portal/web-gui'),
  },
  router: {
    name: 'Routers',
    description: 'MiFi fleet, hotspot clients, vouchers, usage',
    accent: '#16a34a',
    lazy: () => import('@admin-portal/router-gui'),
  },
  vpn: {
    name: 'VPN',
    description: 'WireGuard relays, sessions, services, mesh, traffic',
    accent: '#6366f1',
    lazy: () => import('@admin-portal/vpn-gui'),
  },
} satisfies Record<string, ModuleEntry>;
